import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Divider,
  title: 'Divider',
  category: ComponentCategory.Layout,
};
